const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class SSE extends DataServiceEndPoint {
  static key = "SSE"

  _getMode = () => {
    return this._config.get("sse.v2.mode") || "v2"
  }

  getSubscriptionUrl = () => {
    if (this._getMode() === "dynamic") {
      if (this._config.get("sse.v2.dynamic.useAlternativeNotificationUrl")) {
        return `${this.url}/v1/subscriptions/dynamic`
      }

      return `${this._config.get("sse.v2.dynamic.url")}/subscriptions/v2`
    }

    if (this._config.get("sse.v2.useAlternativeNotificationUrl")) {
      return `${this.url}/v1/subscriptions/v2`
    }

    return `${this._config.get("sse.v2.notificationUrl")}/subscriptions/v2`
  }

  subscribe = (payload) => {
    return this._httpService.put(this.getSubscriptionUrl(), payload, {
      headers: { Authorization: `bearer ${this.token}` },
    })
  }

  unsubscribe = (data) => {
    return this._httpService.delete(this.getSubscriptionUrl(), {
      headers: { Authorization: `bearer ${this.token}` },
      data,
    })
  }
}

module.exports = SSE
